import { KeyAstromTarget } from 'enums/AnalyticsTarget';
import { dtrumEnterAction, dtrumLeaveAction, dtrumReportCustomError } from 'utils/dtrum';

export class DtrumUtils {
    static actionInProgress = new Map();

    static startAction(actionName: KeyAstromTarget) {
        const id = dtrumEnterAction(actionName);
        if (!id) return;
        DtrumUtils.actionInProgress.set(actionName, id);
    }

    static endAction(actionName: KeyAstromTarget) {
        const id = DtrumUtils.actionInProgress.get(actionName);
        if (!id) return;
        DtrumUtils.actionInProgress.delete(actionName);
        dtrumLeaveAction(id);
    }

    static addCustomError(actionName: KeyAstromTarget, error: string) {
        const id = DtrumUtils.actionInProgress.get(actionName);
        if (!id) return;
        dtrumReportCustomError(error, id);
    }
}
